function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import requiredImage from '../fragments/requiredImage.js';
import accentColor from '../fragments/accentColor.js';
import color from '../objects/color.js';
var schema = defineObject('imageGallerySection', {
    images: {
        title: 'Images',
        type: 'array',
        of: [
            requiredImage.fragment
        ]
    },
    accentColor: _object_spread({
        title: 'Accent color'
    }, accentColor.fragment)
}, [
    color.schema.color
]);
var validator = z.object({}).partial();
schema.imageGallerySection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=imageGallerySection.js.map